/*
 * @Author: Sam
 * @Date: 2020-11-10 20:50:40
 * @LastEditTime: 2021-12-16 11:13:15
 * @LastEditors: Sam
 * @Description:
 * @FilePath: \resourcesf:\thework\tofba-client\src\api\waybill.js
 * @可以输入预定的版权声明、个性签名、空行等
 */
import request from '@/utils/request'

// 编辑、新增 页面公共数据
// export function initWaybillRender (data) {
//   return request({
//     url: '/seaair/waybills/initWaybillRender',
//     method: 'post',
//     data,
//   })
// }

// 导入 CDA　或者报关资料
export function uploadWaybillFile(data) {
  return request({
    url: '/seaair/waybills/uploadWaybillFile',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

// 导入 批量下单文件
export function uploadBatchWaybillOrderFile(data) {
  return request({
    url: '/seaair/waybills/clientBatchImporterWaybillOrder',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

// 导入 批量上传运单信息
export function submitBatchWaybillOrder(data) {
  return request({
    url: '/seaair/waybills/submitBatchWaybillOrder',
    method: 'post',
    data,
  })
}

// 保存附件信息
export function saveWaybillFile(data) {
  return request({
    url: '/seaair/waybills/saveWaybillFile',
    method: 'post',
    data,
  })
}
// FBA导入箱单发票
export function doImportPackLists(data) {
  return request({
    url: '/seaair/waybills/doImportPackLists',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
//便捷下单
export function doImportFastCreateOrderModel(data) {
  return request({
    url: '/seaair/waybills/doImportFastCreateOrderModel',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
// 导入箱单发票
export function doImportLiquidationPacking(data) {
  return request({
    url: '/seaair/waybills/doImportLiquidationPacking',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
export function exportFastOrder(data) {
  return request({
    url: '/seaair/waybills/downLoadFastCreateOrderModel',
    method: 'post',
    data,
  })
}
export function downLoadBatchOrderModel(data) {
  return request({
    url: '/seaair/waybills/downLoadBatchCreateOrderModel',
    method: 'get',
    params: data,
  })
}

export function isShowAllPurchaseCodeBySaleId(data) {
  return request({
    url: '/seaair/waybills/isShowAllPurchaseCodeBySaleId',
    method: 'post',
    data,
  })
}

// 查询海空运单状态数据
export function initListPage(data) {
  return request({
    url: '/seaair/waybills/initListPage',
    method: 'post',
    data,
  })
}

// 查询海空运单列表
export function listPage(data) {
  return request({
    url: '/seaair/waybills/listPage',
    method: 'post',
    data,
  })
}

// 查价
export function queryChannelPrices(data) {
  return request({
    url: '/seaair/waybills/queryChannelPrices',
    method: 'post',
    data,
  })
}

// 删除 运单
export function deleteWaybillById(data) {
  return request({
    url: '/seaair/waybills/deleteWaybillById',
    method: 'post',
    params: data,
  })
}
// 运单打回待确认
export function replyWaybill(data) {
  return request({
    url: '/seaair/waybills/replyWaybill',
    method: 'post',
    params: data,
  })
}
// 查看理赔信息
export function showClaim(data) {
  return request({
    url: '/seaair/waybills/showClaim',
    method: 'post',
    params: data,
  })
}

// 查询单个运单
export function getWaybillById(data) {
  return request({
    url: '/seaair/waybills/getWaybillById',
    method: 'post',
    params: data,
  })
}
// 根据国家查询出其相关的FBA仓库
export function queryFbaCodeByCoutry(data) {
  return request({
    url: '/seaair/waybills/queryFbaCodeByCoutry',
    method: 'post',
    params: data,
  })
}
// 匹配国内分区
export function queryInStockChannel(data) {
  return request({
    url: '/seaair/waybills/queryInStockChannel',
    method: 'post',
    data,
  })
}

// 匹配国内分区
export function queryEndOrderChannel(data) {
  return request({
    url: '/seaair/waybills/queryEndOrderChannel',
    method: 'get',
    params: data,
  })
}
// 渠道检索,根据条件取得满足条件的渠道
export function queryMatchProvince(data) {
  return request({
    url: '/seaair/waybills/queryMatchProvince',
    method: 'post',
    data,
  })
}
// FBA下单保存操作
export function saveWaybillFba(data) {
  return request({
    url: '/seaair/waybills/saveWaybillFba',
    method: 'post',
    data,
  })
}

// 解除下单PO限制
export function unfreeze() {
  return request({
    url: '/seaair/waybills/unfreeze',
    method: 'post',
    data:{}
  })
}
// 标准下单保存操作
export function saveWaybillStandard(data) {
  return request({
    url: '/seaair/waybills/saveWaybillStandard',
    method: 'post',
    data,
  })
}

export function towerReportingDeclareValue(data) {
  return request({
    url: '/seaair/waybills/towerReportingDeclareValue',
    method: 'post',
    data,
  })
}

// 上传图片
export function uploadImage(data) {
  return request({
    url: '/seaair/waybills/uploadImage',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

// 查询预约提货列表
export function pageTakeDeliveryOfGoods(data) {
  return request({
    url: '/seaair/waybills/pageTakeDeliveryOfGoods',
    method: 'post',
    data,
  })
}

// 查询预约送仓列表
export function bookingDeliveryList(data) {
  return request({
    url: '/warehouse/send/warehouse/bookingDeliveryList',
    method: 'post',
    data,
  })
}

// 保存预约送仓列表
export function saveDelivery(data) {
  return request({
    url: '/warehouse/send/warehouse/saveDelivery',
    method: 'post',
    data,
  })
}

// 删除预约送仓
export function deleteDelivery(data) {
  return request({
    url: '/warehouse/send/warehouse/delete',
    method: 'post',
    data,
  })
}

// 打印标签
export function pringcreatePdfLabel10x10(data) {
  return request({
    url: '/warehouse/send/warehouse/createPdfLabel10x10',
    method: 'post',
    data,
  })
}

// 打印标签
export function updatelabeltime(data) {
  return request({
    url: '/seaair/printwaybilllabel/updatelabeltime',
    method: 'post',
    data,
  })
}

// 提交预约提货
export function createTakeDeliveryOfGoods(data) {
  return request({
    url: '/seaair/waybills/createTakeDeliveryOfGoods',
    method: 'post',
    data,
  })
}
// 删除预约提货
export function deleteTakeDeliveryOfGoods(data) {
  return request({
    url: '/seaair/waybills/deleteTakeDeliveryOfGoods',
    method: 'post',
    data,
  })
}
// 取消提货
export function cancleTakeDeliveryOfGoods(data) {
  return request({
    url: '/seaair/waybills/cancleTakeDeliveryOfGoods',
    method: 'post',
    data,
  })
}

// 评价预约提货
export function appraisedTakeDeliveryOfGoods(data) {
  return request({
    url: '/seaair/waybills/appraisedTakeDeliveryOfGoods',
    method: 'post',
    data,
  })
}

// 批量交寄 param object.waybillIds[]
export function fetchLiquidationInvoiceMeasurementUnit(data) {
  return request({
    url: '/seaair/waybills/fetchLiquidationInvoiceMeasurementUnit',
    method: 'post',
    data,
  })
}
export function submitOrderExamine(data) {
  return request({
    url: '/seaair/waybills/submitOrderExamine',
    method: 'post',
    data,
  })
}
// 批量打回待确认 param object.waybillIds[]
export function batchReplyWaybill(data) {
  return request({
    url: '/seaair/waybills/batchReplyWaybill',
    method: 'post',
    data,
  })
}

// 合并报关 param object.waybillIds[]
export function mergerDeclaration(data) {
  return request({
    url: '/seaair/waybills/mergerDeclaration',
    method: 'post',
    data,
  })
}

// 取消合并报关 param object.waybillIds[]
export function cancelMergerDeclaration(data) {
  return request({
    url: '/seaair/waybills/cancelMergerDeclaration',
    method: 'post',
    data,
  })
}

// 报关资料 param object.customerId
export function customInfoManage(data) {
  return request({
    url: '/seaair/waybills/customInfoManage',
    method: 'post',
    data,
  })
}

// 批量下载入仓单 param object.customerId
export function batchDownloadWarehouseReceipt(data) {
  return request({
    url: '/seaair/waybills/batchDownloadWarehouseReceipt',
    method: 'post',
    data,
  })
}

// 合并下载入仓单
export function mergeDownloadWarehouseReceipt(data) {
  return request({
    url: '/seaair/waybills/mergeDownloadWarehouseReceipt',
    method: 'post',
    data,
  })
}

// 下载入仓单 param object.customerId
export function downloadWarehouseReceipt(data) {
  return request({
    url: '/seaair/waybills/downloadWarehouseReceipt',
    method: 'post',
    data,
  })
}

// 合并清关 param object.waybillIds[]
export function mergeCustomsClearance(data) {
  return request({
    url: '/seaair/waybills/mergeCustomsClearance',
    method: 'post',
    data,
  })
}

// 取消合并清关 param object.waybillIds[]
export function cancelMergeCustomsClearance(data) {
  return request({
    url: '/seaair/waybills/cancelMergeCustomsClearance',
    method: 'post',
    data,
  })
}


// 查询合并清关单号
export function asyncLoadingMergeClearanceWaybillNos(data) {
  return request({
    url: '/seaair/seaairlist/asyncLoadingMergeClearanceWaybillNo',
    method: 'post',
    data,
  })
}

// 查询合并报关单号
export function asyncLoadingOtherWaybillNos(data) {
  return request({
    url: '/seaair/seaairlist/asyncLoadingOtherWaybillNo',
    method: 'post',
    data,
  })
}
// 打印运单标签

// 打印运单标签10X10（pdf）
export function createPdfLabel10x10(data) {
  return request({
    url: '/seaair/waybills/createPdfLabel10x10',
    method: 'post',
    // params: data,
    data,
  })
}
// 打印运单标签10X8（pdf）
export function createPdfLabel10x8(data) {
  return request({
    url: '/seaair/waybills/createPdfLabel10x8',
    method: 'post',
    data,
  })
}
// 打印运单标签A4（pdf）
export function createPdfLabelA4(data) {
  return request({
    url: '/seaair/waybills/createPdfLabelA4',
    method: 'post',
    data,
  })
}
// 打印运单标签（10*10）
export function printWaybillLabel(data) {
  return request({
    url: '/seaair/waybills/printWaybillLabel',
    method: 'post',
    data,
  })
}

// 问题件 queryQuestionsByWaybillId

export function queryQuestionsByWaybillId(data) {
  return request({
    url: '/seaair/waybills/queryQuestionsByWaybillId',
    method: 'post',
    data,
  })
}
// 初始化 评价

export function initData(data) {
  return request({
    url: '/seaair/waybillce/initData',
    method: 'post',
    // data
  })
}

// 详情
export function chatrecordlist(data) {
  return request({
    url: '/seaair/waybillce/waybilleldetails',
    method: 'post',
    params: data,
  })
}
// 保存评价
export function customerevaluationSave(data) {
  return request({
    url: '/seaair/waybillce/save',
    method: 'post',
    data,
  })
}
// 追加评价
export function waybillelAddComments(data) {
  return request({
    url: '/seaair/waybillce/waybillelAddComments',
    method: 'post',
    data,
  })
}
// 追加评价
export function initWaybillState(data) {
  return request({
    url: '/seaair/waybills/initWaybillState',
    method: 'post',
    params: data,
  })
}
// 判断渠道的计费类型
export function initWaybillInStockChannel(data) {
  return request({
    url: '/seaair/waybills/initWaybillInStockChannel',
    method: 'post',
    params: data,
  })
}

// 下载已上传装箱单
export function exportLiquidationPacking(data) {
  return request({
    url: '/seaair/waybills/exportLiquidationPacking',
    method: 'post',
    params: data,
  })
}

export function downLoadFastModerById(data) {
  return request({
    url: '/seaair/waybills/downLoadFastOrderDataModelByIds',
    method: 'post',
    params: data,
  })
}

export function batchReportWaybillData(data) {
  return request({
    url: '/seaair/waybills/batchReportWaybillData',
    method: 'post',
    data,
  })
}
export function batchExportTrackingNumber(data) {
  return request({
    url: '/seaair/waybills/batchExportTrackingNumber',
    method: 'post',
    data,
  })
}
export function batchExportWaybillInfo(data) {
  return request({
    url: '/seaair/waybills/batchExportWaybillInfo',
    method: 'post',
    data,
  })
}
export function batchDownloadDeclarationSlip(data) {
  return request({
    url: '/seaair/waybills/batchDownloadDeclarationSlip',
    method: 'post',
    data,
  })
}export function batchDownloadTaxRefund(data) {
  return request({
    url: '/seaair/waybills/batchDownloadTaxRefund',
    method: 'post',
    data,
  })
}
export function reportWaybillData(data) {
  return request({
    url: '/seaair/waybills/reportWaybillData',
    method: 'post',
    data,
  })
}

// 下载箱单跟踪号
export function exportTrackingNumber(data) {
  return request({
    url: '/seaair/waybills/exportTrackingNumber',
    method: 'post',
    params: data,
  })
}

// 通过运单号检索订单信息
export function searchOrderByWaybillNo(data) {
  return request({
    url: '/seaair/waybills/searchOrderByWaybillNo',
    method: 'post',
    params: data,
  })
}

// 通过运单号检索订单信息
export function clientQuickSearch(data) {
  return request({
    url: 'seaair/open/message/clientQuickSearch',
    method: 'post',
    data,
  })
}
// 通过参考号检索订单信息
export function searchOrderByReferenceNo(data) {
  return request({
    url: '/seaair/waybills/searchOrderByReferenceNo',
    method: 'post',
    params: data,
  })
}
// 模糊搜索
export function searchLikeOrderToCustomer(data) {
  return request({
    url: '/seaair/waybills/searchLikeOrderToCustomer',
    method: 'post',
    params: data,
  })
}
// 查询附件信息
export function queryWaybillFileList(data) {
  return request({
    url: '/seaair/waybills/queryWaybillFileList',
    method: 'post',
    params: data,
  })
}
// 删除附件信息
export function deleteWaybillFile(data) {
  return request({
    url: '/seaair/waybills/deleteWaybillFile',
    method: 'post',
    params: data,
  })
}
// 查看箱单原始数据
export function querySubWaybill(data) {
  return request({
    url: '/seaair/waybills/querySubWaybill',
    method: 'post',
    params: data,
  })
}
// 查看箱单原始数据
export function queryInStockData(data) {
  return request({
    url: '/seaair/waybills/viewInStockData',
    method: 'post',
    params: data,
  })
} 
// 查看费用信息
export function queryWaybillReceive(data) {
  return request({
    url: '/seaair/waybills/queryWaybillReceive',
    method: 'post',
    data,
    // params: data
  })
}
// 客户远程搜索
export function customerReceivables(data) {
  return request({
    url: '/seaair/g2gairseaairwaybills/customerReceivables',
    method: 'post',
    data,
  })
}
// 查询收货地址
export function getImporterAndPickupAddr(data) {
  return request({
    url: '/seaair/g2gairseaairwaybills/getImporterAndPickupAddr',
    method: 'post',
    data,
  })
}
// 初始化
export function initPageData(data) {
  return request({
    url: '/seaair/g2gairseaairwaybills/initPageData',
    method: 'post',
  })
}
// 新增客户收货地址
export function saveCustomerPickupAddress(data) {
  return request({
    url: '/seaair/g2gairseaairwaybills/saveCustomerPickupAddress',
    method: 'post',
    data,
  })
}
// 保存
export function saveG2GAirWaybill(data) {
  return request({
    url: '/seaair/g2gairseaairwaybills/saveG2GAirWaybill',
    method: 'post',
    data,
  })
}
// 进口商信息
export function queryCustomerImporter(data) {
  return request({
    url: '/seaair/waybills/queryCustomerImporter ',
    method: 'post',
    data,
  })
}
// 下载文件
export function downloadFile(data) {
  return request({
    url: '/seaair/waybills/downloadFile',
    method: 'post',
    responseType: 'blob',
    params: data,
  })
}
// 计费重 体积等字段
export function getPackingList(data) {
  return request({
    url: '/seaair/waybills/getPackingList',
    method: 'post',
    params: data,
  })
}
// 一键中转下单（至海外仓）
export function transferCreateAboradWaybill(data) {
  return request({
    url: '/seaair/waybills/transferCreateAboradWaybill',
    method: 'post',
    params: data,
  })
}
// 取消一键中转下单（至海外仓）
export function cancelTransferAboradWaybill(data) {
  return request({
    url: '/seaair/waybills/cancelTransferAboradWaybill',
    method: 'post',
    params: data,
  })
}

// 发票SKU查询
export function queryApiSkuInfos(data) {
  return request({
    url: '/customer/skuInfos/queryApiSkuInfos',
    method: 'post',
    data,
  })
}

// 发票SKU查询
export function downLoadWarehouse(data) {
  return request({
    url: '/seaair/waybills/downLoadWarehouse',
    method: 'post',
    params: data,
  })
}

// 发票SKU查询
export function getTrackInfoByWaybillId(data) {
  return request({
    url: '/setting/tracknodeabnormal/findProgressAllByWaybillStatus',
    method: 'post',
    data,
  })
}

// 查询卡铁联运轨迹
export function getTruckRailwayTracesByAssetNo(data) {
  return request({
    url: '/seaair/waybills/getTruckRailwayTracesByAssetNo',
    method: 'post',
    data,
  })
}

// 获取运单的异常状态
export function getCheckWaybillStatus(data) {
  return request({
    url: '/seaair/seaairlist/checkWaybillStatus',
    method: 'post',
    data,
  })
}

// 报关核对草确认
export function getWaybillCheckDraft(data) {
  return request({
    url: '/seaair/seaairlist/waybillCheckDraft',
    method: 'post',
    data,
  })
}
// 谷歌地址搜索
export function googleAddressSearch(params) {
  return request({
    url: '/seaair/waybills/google',
    method: 'post',
    data: params,
  })
}
// 校验电话号码与国家是否匹配
export function waybillsvalidatePhone(params) {
  return request({
    url: '/seaair/waybills/validatePhone',
    method: 'post',
    data: params
  })
}
// 校验地址
export function waybillsvalidateAddress(params) {
  return request({
    url: '/seaair/waybills/validateAddress',
    method: 'post',
    data: params
  })
}

// 校验是否偏远
export function validateRemoteType(params) {
  return request({
    url: '/seaair/waybills/validateRemoteType',
    method: 'post',
    data: params
  })
}

// 校验dispatchAddressCode
export function validationDispatchAddressCode(params) {
  return request({
    url: '/seaair/waybills/validationDispatchAddressCode',
    method: 'post',
    data: params
  })
}

// 校验人名
export function waybillsvalidateName(params) {
  return request({
    url: '/seaair/waybills/validateName',
    method: 'post',
    data: params
  })
}
// 校验公司名
export function waybillsvalidateCompanyName(params) {
  return request({
    url: '/seaair/waybills/validateCompany',
    method: 'post',
    data: params
  })
}
// 常用尺寸列表
export function getUsedSizeList(params) {
  return request({
    url: '/customer/box/size/list',
    method: 'post',
    data: params
  })
}

// 保存常用尺寸
export function saveUsedSize(params) {
  return request({
    url: '/customer/box/size/batch/save',
    method: 'post',
    data: params
  })
}

// 根据国家获取机场
export function configairportList(data) {
  return request({
    url: '/setting/configairport/findBycountryIdList',
    method: 'post',
    data: data
  })
}


// 根据国家获取港口
export function findBycountryIdPortList(data) {
  return request({
    url: '/setting/configport/findBycountryIdPortList',
    method: 'post',
    data: data
  })
}

// 判断客户是否需要签订合同
export function isNeedSignContract() {
  return request({
    url: '/customer/info/judgeIsNeedContract',
    method: 'post',
  })
}


// send修改预报信息
export function updateSendWaybillInfo(data) {
  return request({
    url: '/seaair/waybills/customerSaveAmazonSend',
    method: 'post',
    data
  })
}
// send修改发件人信息
export function updateWaybillSenderInfo(data) {
  return request({
    url: '/seaair/waybills/customerChangeSenderInfo',
    method: 'post',
    data
  })
}
// send修改进口商信息
export function updateWaybillImporterInfo(data) {
  return request({
    url: '/seaair/waybills/customerChangeImportInfo',
    method: 'post',
    data
  })
}
// send修改箱单发票信息
export function saveSendPackageInvoice(data) {
  return request({
    url: '/seaair/waybills/saveSendPackageInvoice',
    method: 'post',
    data
  })
}
// send下载箱单发票
export function exportSendLiquidationPacking(data) {
  return request({
    url: '/seaair/waybills/exportSendLiquidationPacking',
    method: 'post',
    data
  })
}
// send 提货地址信息
export function validatePickup(data) {
  return request({
    url: '/seaair/waybills/validatePickUp',
    method: 'post',
    data
  })
}

// 清提派页面打开加载的内容
export function initHdWaybill(data) {
  return request({
    url: '/seaair/seaairwaybill/qingtipai/initHdWaybill',
    method: 'post',
    data,
  })
}

// 根据国家加载客户进口商
export function initCustomerImporter(data) {
  return request({
    url: '/seaair/seaairwaybill/qingtipai/initCustomerImporter',
    method: 'post',
    data,
  })
}
